export default __webpack_public_path__ + "media/attilaVid.8e4105a5.mp4";